
import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";
import CrmHistoryCall from "@/models/crm/crm-history-call";

export default Vue.extend({
	data() {
		return {
			props: new CrmHistoryCall()
		};
	},
	props: {
		event: {
			required: true,
			type: Object as () => CrmHistory
		},
	},
	components: {

	}
});
